module.exports = __webpack_public_path__ + "assets/img/19ec10628c4ca2e7c0715bc3445e501f.svg";